<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page" v-else-if="loaded" >
            <div class="col-12 col-md-8 offset-md-2 mt-5" >

                <b-form  @submit.prevent="submit" class="atlass-form col-12 mb-5" >
                    
                    <div class="row no-gutters">
                        
                        <div class="col-12 form-group" >
                            <h3 class="h3 m-0 graymedium-color" > <font-awesome-icon :icon="['far', 'building']" /> ORGANIZATION </h3>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <label> NAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="newOrg.name"
                            required
                            class="form-control"
                            placeholder="Name">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> STATUS </label>
                            <b-form-select v-model="newOrg.status" class="form-control" :options="statusOptions"></b-form-select>
                        </div>

                        <div class="col-12 form-group" >
                            <label> SUBSCRIPTION: </label>
                            <b-form-select class="form-control" v-model="newOrg.subscription" :options="subOptions"></b-form-select>
                        </div>

                        <div class="col-12 form-group mt-3" >
                             <h3 class="h3 m-0 graymedium-color" > <font-awesome-icon :icon="['fa', 'user']" /> Owner </h3>
                        </div>

                        <div class="col-12 form-group" >
                            <label> FIRSTNAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="newOrg.owner.firstname"
                            required
                            class="form-control"
                            placeholder="Owner firstname">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> LASTNAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="newOrg.owner.lastname"
                            required
                            class="form-control"
                            placeholder="Owner Lastname">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> EMAIL: </label>
                            <b-form-input 
                            type="text"
                            v-model="newOrg.owner.email"
                            required
                            class="form-control"
                            placeholder="Owner email">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> PASSWORD: </label>
                            <b-form-input 
                            type="password"
                            v-model="newOrg.owner.password"
                            required
                            class="form-control"
                            placeholder="Owner password">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <b-button type="submit" variant="primary" class="btn-sm-w" >Save</b-button>
                        </div>
                        
                    </div>
                </b-form>

            </div> <!-- .col-12 col-md-8 -->
        </div> <!-- .template-page --> 

</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default {
    name: 'OrganizationNew',
    props: {
        data: { 
            type: [String],
        },
        pageType:{
            type: [String],
            default: 'edit'
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            timeout: 100,
            modalState: false,
            newOrg:{
                name: '',
                status: 0,
                subscription:'',
                owner: {
                    firstname:'',
                    lastname:'',
                    email: '',
                    password: '',
                },
            },
            subscriptions:[],
            subOptions: [ { value: null, text: '-- Select subscription --' } ],
            statusOptions:[
                { value: 0, text: 'Inactive' },
                { value: 1, text: 'Active' },
            ],
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        console.log( "API URL: "+process.env.ROOT_API )
        
        
        
        if( this.subscriptions.length < 1 ){
            this.getSubscriptions()
        }
        this.loaded = true;
    },
    beforeDestroy() {
    },
    methods: {
        test(){
            console.log( this.$parent.$parent )
            this.$parent.$parent.get_organizations()
        },
        getSubscriptions(){
            
            const db = this.$firebase.firestore();
            db.collection('subscriptions')
            .get()
            .then(snap => {
                const results = [];
                const subOptions = [];

                snap.forEach(doc => {
                    //console.log(doc.data())
                    let item = doc.data()
                    item.id = doc.id
                    results.push( item );
                });
                
                results.sort((a, b) => a.price - b.price);
                results.forEach(item =>{
                    subOptions.push( { value: item.id, text: item.name + " ( €"+item.price+" )" } );
                })
                
                this.subscriptions = results;
                this.subOptions = subOptions;
            });
            
        },
        AddOrganization(){
            
            if( this.subscriptions.length < 1 ){
                this.getSubscriptions()
            }
            this.fModalOpen( null );
            
        },
        submit(){

            let params = Cookies.get('user-token')
            
            //console.log( this.newOrg )
            let data = this.newOrg
            //console.log(data)
            //let data = JSON.stringify( this.newOrg )
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/admin/createUser', headers: headers, data: data })
                .then(resp => {
                
                console.log(resp)
                
                if( resp.status == 200 ){
                    let r = resp.data;
                    if( r.status == 100 ){
                        
                        setTimeout(function(){ 
                            this.$parent.$parent.get_organizations()
                            this.$parent.fModalClose()
                        }.bind(this), 1500 );
                            
                    }
                }
                    
                
            }).catch(error => {
                console.log(error)
            }); //end axios 
            
        },
    },
    computed: {

    },
    watch: {

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    
</style>



// WEBPACK FOOTER //
// src/components/organizationNew.vue